import React, { useEffect, useState } from 'react';
import { getDocumentList } from '../documents/apiController';
import ModalComponent from '../common/Modal/modal';
import { CustomButton } from '../../widgets';
import { FieldItem, FIELD_TYPES } from '../../widgets/fields';

const SelectDocumentModal = ({ onSelect, onClose }) => {
  const [documentList, setDocumentList] = useState<any[]>([]);
  const [selectedDoc, setSelectedDoc] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const projectDataStr = localStorage.getItem("projectData");
        if (!projectDataStr) {
          setIsLoading(false);
          return;
        }
        const projectData = JSON.parse(projectDataStr);
        const documentResponse = await getDocumentList(projectData.id, 1, 100);
        
        if (documentResponse) {
          setDocumentList(documentResponse.map((doc: any) => ({
            value: doc.id,
            label: doc.name
          })));
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  const handleSelect = () => {
    if (selectedDoc) {
      onSelect({
        docselected: selectedDoc
      });
    }
  };

  return (
    <ModalComponent
      width={"350px"}
      isOpen={true}
      onClose={onClose}
      header="Select Document"
      centered={true}
      customClass='template-modal'
      body={
        <div className="form-template p-3">
          {isLoading ? (
            <div className="text-center p-3">Loading documents...</div>
          ) : (
            <>
              {documentList.length > 0 ? (
                <FieldItem
                  name="docselected"
                  label="Select Document"
                  placeholder="Choose document"
                  type={FIELD_TYPES.DROP_DOWN}
                  value={selectedDoc}
                  values={documentList}
                  onChange={(...val: any) => setSelectedDoc(val[0])}
                  isMandatory={true}
                />
              ) : (
                <div className="text-center p-3">
                  No documents found. Please create one under documents tab.
                </div>
              )}
            </>
          )}
        </div>
      }
      footer={
        <>
          <CustomButton 
            text="Confirm" 
            type="primary" 
            onClick={handleSelect}
            isDisabled={!selectedDoc || isLoading}
          />
        </>
      }
    />
  );
};

export default SelectDocumentModal;
